module.exports = __webpack_public_path__ + "static/img/about2.dff0999.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/about2.jpg
// module id = mvsD
// module chunks = 1